module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "rateassist-details-t"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.init) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "shadow clearfix"
  }, [_c('hr', {
    staticClass: "hr-text",
    attrs: {
      "data-content": "Details"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Origin Location")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.locationSearchResults,
      "title": "Origin Location",
      "placeHolder": "Type to search",
      "initVal": _vm.entity.originLocation,
      "fnFormatText": _vm.displayLocation,
      "fnSelectValue": _vm.displayLocation
    },
    on: {
      "changing": function (data) { return _vm.locationSearchText = data; },
      "selection-made": function (l) { return _vm.selectLocation(l, 'originLocation'); }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Destination Location")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.locationSearchResults,
      "title": "Destination Location",
      "placeHolder": "Type to search",
      "initVal": _vm.entity.destinationLocation,
      "fnFormatText": _vm.displayLocation,
      "fnSelectValue": _vm.displayLocation
    },
    on: {
      "changing": function (data) { return _vm.locationSearchText = data; },
      "selection-made": function (l) { return _vm.selectLocation(l, 'destinationLocation'); }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("On Carriage Location")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.locationSearchResults,
      "title": "On Carriage Location",
      "placeHolder": "Type to search",
      "initVal": _vm.entity.onCarriageLocation,
      "fnFormatText": _vm.displayLocation,
      "fnSelectValue": _vm.displayLocation
    },
    on: {
      "changing": function (data) { return _vm.locationSearchText = data; },
      "selection-made": function (l) { return _vm.selectLocation(l, 'onCarriageLocation'); }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Pre Carriage Location")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.locationSearchResults,
      "title": "Pre Carriage Location",
      "placeHolder": "Type to search",
      "initVal": _vm.entity.preCarriageLocation,
      "fnFormatText": _vm.displayLocation,
      "fnSelectValue": _vm.displayLocation
    },
    on: {
      "changing": function (data) { return _vm.locationSearchText = data; },
      "selection-made": function (l) { return _vm.selectLocation(l, 'preCarriageLocation'); }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "ct"
    }
  }, [_vm._v("Container Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.containerType),
      expression: "entity.containerType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "ct"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "containerType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.containers), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "wl"
    }
  }, [_vm._v("Wood Loose")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.woodLoose),
      expression: "entity.woodLoose"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "wl"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entity, "woodLoose", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.woodLooses), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.id
      }
    }, [_vm._v(_vm._s(opt.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "min"
    }
  }, [_vm._v("Is Minimum?")]), _vm._v(" "), _c('div', {
    staticClass: "material-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.minimumRate),
      expression: "entity.minimumRate"
    }],
    attrs: {
      "id": "min",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.minimumRate) ? _vm._i(_vm.entity.minimumRate, null) > -1 : (_vm.entity.minimumRate)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.minimumRate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity, "minimumRate", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity, "minimumRate", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity, "minimumRate", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-success",
    attrs: {
      "for": "min"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "calcMin"
    }
  }, [_vm._v("Calculated Breakpoint Previous Band")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.calculatedMinimum),
      expression: "entity.calculatedMinimum"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "calcMin",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.entity.calculatedMinimum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "calculatedMinimum", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "calcMax"
    }
  }, [_vm._v("Calculated Breakpoint Current Band")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.calculatedMaximum),
      expression: "entity.calculatedMaximum"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "calcMax",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.entity.calculatedMaximum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "calculatedMaximum", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-4"
  }, _vm._l((_vm.numericalFields), function(field) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "form-label",
      attrs: {
        "for": field
      }
    }, [_vm._v(_vm._s(_vm.deCamel(field)))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entity[field]),
        expression: "entity[field]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "id": field
      },
      domProps: {
        "value": (_vm.entity[field])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.entity, field, $event.target.value)
        }
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "routingInfo"
    }
  }, [_vm._v("Routing Info")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.routingInfo),
      expression: "entity.routingInfo"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "routingInfo"
    },
    domProps: {
      "value": (_vm.entity.routingInfo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "routingInfo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "placeOfDelivery"
    }
  }, [_vm._v("Place of Delivery")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.placeOfDelivery),
      expression: "entity.placeOfDelivery"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "placeOfDelivery"
    },
    domProps: {
      "value": (_vm.entity.placeOfDelivery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "placeOfDelivery", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "placeOfReceipt"
    }
  }, [_vm._v("Place of Receipt")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.placeOfReceipt),
      expression: "entity.placeOfReceipt"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "placeOfReceipt"
    },
    domProps: {
      "value": (_vm.entity.placeOfReceipt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "placeOfReceipt", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "portOfLoading"
    }
  }, [_vm._v("Port of Loading")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.portOfLoading),
      expression: "entity.portOfLoading"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "portOfLoading"
    },
    domProps: {
      "value": (_vm.entity.portOfLoading)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "portOfLoading", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "portOfDischarge"
    }
  }, [_vm._v("Port of Discharge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.portOfDischarge),
      expression: "entity.portOfDischarge"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "portOfDischarge"
    },
    domProps: {
      "value": (_vm.entity.portOfDischarge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "portOfDischarge", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n              " + _vm._s(_vm.saveOrUpdate) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.doClear
    }
  }, [_vm._v("\n              Clear\n            ")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [(!_vm.fetching) ? _c('vue-table', {
    attrs: {
      "maxItems": _vm.count,
      "tableData": _vm.details,
      "tableTitle": "Lines",
      "showEdit": true,
      "showDelete": true,
      "showSelectAll": true,
      "allowSelect": true,
      "countVisible": false,
      "usePages": true,
      "pageNumber": _vm.pageNumber,
      "fields": [{
          header: 'Container Type',
          prop: function (item) { return this$1.getOptionName(item.containerType); }
        },
        {
          header: 'Wood Loose',
          prop: function (item) { return this$1.getOptionName(item.woodLoose); }
        },
        {
          header: 'Pre Carriage',
          prop: function (item) { return item.preCarriageLocation ? item.preCarriageLocation.name : ''; }
        },
        {
          header: 'Pre Carriage Rate',
          prop: 'preCarriageRate',
          numericalField: true
        },
        {
          header: 'Origin',
          prop: function (item) { return item.originLocation ? item.originLocation.name : ''; }
        },
        {
          header: 'Destination',
          prop: function (item) { return item.destinationLocation ? item.destinationLocation.name : ''; }
        },
        {
          header: 'Rate',
          prop: 'lineRate',
          numericalField: true
        },
        {
          header: 'On Carriage',
          prop: function (item) { return item.onCarriageLocation ? item.onCarriageLocation.name : ''; }
        },
        {
          header: 'On Carriage Rate',
          prop: 'onCarriageRate',
          numericalField: true
        },
        {
          header: 'Min. Distance',
          prop: 'minimumDistance',
          numericalField: true
        },
        {
          header: 'Max. Distance',
          prop: 'maximumDistance',
          numericalField: true
        },
        {
          header: 'Min. Breakpoint',
          prop: 'minimumBreakpoint',
          numericalField: true
        },
        {
          header: 'Max. Breakpoint',
          prop: 'maximumBreakpoint',
          numericalField: true
        }
      ]
    },
    on: {
      "pages-remaining": function($event) {
        return _vm.$emit('loadMore')
      },
      "page-back": function($event) {
        return _vm.$emit('loadBack')
      },
      "table-edit-request": _vm.updateActive,
      "table-delete-request": _vm.doDelete,
      "select-all": _vm.deleteAll,
      "filtering-or-sorting": _vm.getNewData
    }
  }) : _c('Loader')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "shadow clearfix"
  }, [_c('blockquote', [_vm._v("\n          Mass Tariff Line Update\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "line-download"
  }, [_c('hr', {
    staticClass: "hr-text",
    attrs: {
      "data-content": "Step 1 - First download the results shown above"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('parse-from-json', {
    attrs: {
      "json": _vm.detailsToSpreadsheet,
      "fileName": _vm.fileName,
      "disabled": false
    }
  })], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-text",
    attrs: {
      "data-content": "Step 2 - Then upload your revisions"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('parse-to-json', {
    on: {
      "parse-start": _vm.parsing,
      "parse-complete": _vm.parsed
    }
  })], 1), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('blockquote', [_vm._v("\n          Tariff Line Calculator\n        ")]), _vm._v(" "), _c('hr', {
    staticClass: "hr-text",
    attrs: {
      "data-content": "Click below to updated Calculated values for the lines"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn btn-info sq",
    on: {
      "click": _vm.doCalc
    }
  }, [_vm._v("\n            Calculate "), _c('i', {
    staticClass: "fa fa-calculator"
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07a6ceb7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/Tariff/TariffDetails.vue
// module id = 2082
// module chunks = 1